module.exports = __webpack_public_path__ + "static/media/addfrommap_itinerary_emptystate.ed28cfa8.svg";